import * as Sentry from "@sentry/nextjs"

/**
 * Gửi lỗi lên Sentry với context tag.
 * Tự động bỏ qua AbortError (timeout / component unmount).
 *
 * @param {Error} error - Lỗi bắt được từ catch block
 * @param {string} context - Tên hàm/màn hình để dễ lọc trên Sentry dashboard
 *
 * @example
 * } catch (error) {
 *   reportError(error, "fetchDevice")
 * }
 */
export function reportError(error, context) {
  if (error?.name === "AbortError") return
  Sentry.withScope((scope) => {
    if (context) scope.setTag("context", context)
    Sentry.captureException(error)
  })
}
